import { studioAxiosInstance } from "../../processes/api/instances";
import { BaseApi } from "./BaseApi";

export class BaseStudioApi extends BaseApi {
  protected axiosInstance = studioAxiosInstance;

  public static getBaseURL(): string {
    const baseUrl = studioAxiosInstance.defaults.baseURL || "";

    return baseUrl.replace(/\/3d\/?$/, "");
  }
}
